import troy from '../../assets/Games2022/A_Total_War_Saga_TROY.jpg'
import drift from '../../assets/Games2022/Absolute_Drift.jpg'
import aeronautica from '../../assets/Games2022/Aeronautica_Imperialis_Flight_Command.jpg'
import wonders from '../../assets/Games2022/Age_of_Wonders_Planetfall.jpg'
import ancient from '../../assets/Games2022/AncientEnemy.jpg'
import aporia from '../../assets/Games2022/Aporia_Beyond_The_Valley.jpg'
import ato from '../../assets/Games2022/Ato.jpg'
import showdown from '../../assets/Games2022/Big_Crown_Showdown.jpg'
import bonfire from '../../assets/Games2022/Bonfire_Peaks.jpg'
import chaos from '../../assets/Games2022/ChaosReborn.jpg'
import chroma from '../../assets/Games2022/ChromaSquad.jpg'
import chronicon from '../../assets/Games2022/Chronicon.jpg'
import chuchel from '../../assets/Games2022/Chuchel.jpg'
import climber from '../../assets/Games2022/CityClimber.jpg'
import concrete from '../../assets/Games2022/ConcreteJungle.jpg'
import crazy from '../../assets/Games2022/Crazy_Machines_3.jpg'
import cyrofall from '../../assets/Games2022/Cyrofall.jpg'
import danger from '../../assets/Games2022/Danger_Scavenger.jpg'
import dark from '../../assets/Games2022/Dark_Nights_with_Poe_and_Munro.jpg'
import demolish from '../../assets/Games2022/Demolish_Build_2018.jpg'
import desolate from '../../assets/Games2022/Desolate.jpg'
import discolored from '../../assets/Games2022/Discolored.jpg'
import driftland from '../../assets/Games2022/DriftlandTheMagicalRevival.jpg'
import dude from '../../assets/Games2022/Dude_Stop.jpg'
import eternal from '../../assets/Games2022/Eternal_Hope.jpg'
import factory from '../../assets/Games2022/FactoryTown.jpg'
import final from '../../assets/Games2022/FinalVendetta.jpg'
import first from '../../assets/Games2022/First_Class_Trouble.jpg'
import fit from '../../assets/Games2022/FitForAKing.jpg'
import fury from '../../assets/Games2022/FuryUnleashed.jpg'
import geneshift from '../../assets/Games2022/Geneshift_BattleRoyale.jpg'
import niko from '../../assets/Games2022/HereComesNiko.jpg'
import house from '../../assets/Games2022/House.jpg'
import idleone from '../../assets/Games2022/Idle_Champions_Polymorphed_Shandie_Skin_Feat_Pack.jpg'
import idletwo from '../../assets/Games2022/Idle_Champions_Prismeer_Sentry_Skin_Feat_Pack.jpg'
import imagine from '../../assets/Games2022/Imagine_Earth.jpg'
import jars from '../../assets/Games2022/Jars.jpg'
import kaiju from '../../assets/Games2022/KaijuWars.jpg'
import killrun from '../../assets/Games2022/Killrun.jpg'
import kitaria from '../../assets/Games2022/Kitaria_Fables.jpg'
import inferno from '../../assets/Games2022/Little_Inferno.jpg'
import nova from '../../assets/Games2022/Lost_Nova.jpg'
import lucifer from '../../assets/Games2022/Lucifer_Within_Us.jpg'
import mad from '../../assets/Games2022/Mad_Experiments_Escape_Room.jpg'
import maiden from '../../assets/Games2022/Maiden_and_Spell.jpg'
import mech from '../../assets/Games2022/Mech_Mechanic_Simulator.jpg'
import men from '../../assets/Games2022/Men_of_War_Assault_Squad_2.jpg'
import moon from '../../assets/Games2022/Moon_Hunters.jpg'
import orbi from '../../assets/Games2022/OrbiUniverso.jpg'
import paper from '../../assets/Games2022/Paperball.jpg'
import paradise from '../../assets/Games2022/ParadiseLost.jpg'
import pendragon from '../../assets/Games2022/Pendragon.jpg'
import plague from '../../assets/Games2022/PlagueInc.jpg'
import plate from '../../assets/Games2022/PlateUp.jpg'
import primal from '../../assets/Games2022/Primal_Light.jpg'
import rings from '../../assets/Games2022/Rings_of_Saturn.jpg'
import seals from '../../assets/Games2022/SealsOfTheBygone.jpg'
import space from '../../assets/Games2022/Space_Crew_Legendary_Edition.jpg'
import sunlight from '../../assets/Games2022/Sunlight.jpg'
import swords from '../../assets/Games2022/Swords_n_Magic_and_Stuff_EA.jpg'
import tanuki from '../../assets/Games2022/Tanuki.jpg'
import tenderfoot from '../../assets/Games2022/Tenderfoot_Tactics.jpg'
import dungeon from '../../assets/Games2022/The_Dungeon_Beneath.jpg'
import galactic from '../../assets/Games2022/The_Galactic_Junkers.jpg'
import hex from '../../assets/Games2022/The_Hex.jpg'
import turing from '../../assets/Games2022/The_Turing_Test.jpg'
import turnip from '../../assets/Games2022/Turnip_Boy_Commits_Tax_Evasion.jpg'
import uligo from '../../assets/Games2022/Uligo_A_Slimes_Hike.jpg'
import vibrant from '../../assets/Games2022/Vibrant_Venture.jpg'
import viscera from '../../assets/Games2022/Viscera_Cleanup_Detail.jpg'
import warhammer from '../../assets/Games2022/Warhammer_40000_Gladius_Relics_of_War_2018.jpg'
import warsaw from '../../assets/Games2022/Warsaw.jpg'
import wunderling from '../../assets/Games2022/Wunderling_DX.jpg'
import suck from '../../assets/Games2022/You_Suck_At_Parking.jpg'
import zombie from '../../assets/Games2022/Zombie_Rollerz.jpg'
import displate from '../../assets/Games2022/Displate.png'
import yogs from '../../assets/Games2022/yogs.png'
import fresh from '../../assets/Games2022/fresh.png'
import fanatical from '../../assets/Games2022/fanatical.png'

export const games = [
  {
    name: 'Age of Wonders: Planetfall (2019)',
    detail: 'Beautiful Sci-Fi 4X',
    image: wonders,
    dev: 'Paradox',
    link: 'https://store.steampowered.com/app/718850/Age_of_Wonders_Planetfall/',
  },
  {
    name: 'PlateUp! (2022)',
    detail: 'Brilliant Cooking Chaos',
    image: plate,
    dev: "It's happening",
    link: 'https://store.steampowered.com/app/1599600/PlateUp/',
  },
  {
    name: 'You Suck At Parking (2022)',
    detail: 'Party Racing Fun',
    image: suck,
    dev: 'Happy Volcano',
    link: 'https://store.steampowered.com/app/837880/You_Suck_at_Parking/',
  },
  {
    name: 'Here Comes Niko! (2021)',
    detail: 'Cute Cozy Platforming',
    image: niko,
    dev: 'Gears for Breakfast',
    link: 'https://store.steampowered.com/app/925950/Here_Comes_Niko/',
  },
  {
    name: 'A Total War Saga: TROY (2021)',
    detail: 'Swords Sandals Slaughter',
    image: troy,
    dev: 'Creative Assembly',
    link: 'https://store.steampowered.com/app/1099410/A_Total_War_Saga_TROY/',
  },
  {
    name: 'First Class Trouble (2021)',
    detail: 'Cruise Ship Among Us',
    image: first,
    dev: 'Invisible Walls',
    link: 'https://store.steampowered.com/app/953880/First_Class_Trouble/?curator_clanid=3324095666',
  },
  {
    name: 'Lost Nova (2022)',
    detail: 'Explore Build Craft',
    image: nova,
    dev: 'HopFrog',
    link: 'https://store.steampowered.com/app/1603410/Lost_Nova/',
  },
  {
    name: 'Factory Town (2021)',
    detail: 'Automate Your Town',
    image: factory,
    dev: 'Erik Asmussen',
    link: 'https://store.steampowered.com/app/860890/Factory_Town/?curator_clanid=32938557',
  },
  {
    name: 'Imagine Earth (2021)',
    detail: 'Planetary Colonization',
    image: imagine,
    dev: 'Serious Bros.',
    link: 'https://store.steampowered.com/app/280720/Imagine_Earth/',
  },
  {
    name: 'ConnecTank (2021)',
    detail: 'Coop Conveyer Battles',
    image: 'https://cdn.cloudflare.steamstatic.com/steam/apps/1597200/header.jpg?t=1633719952',
    dev: 'YummyYummyTummy',
    link: 'https://store.steampowered.com/app/1597200/ConnecTank/',
  },
  {
    name: 'Final Vendetta (2022)',
    detail: 'Side Scrolling Brawler',
    image: final,
    dev: 'Numbskull Games',
    link: 'https://store.steampowered.com/app/1891090/Final_Vendetta/',
  },
  {
    name: 'Bonfire Peaks (2021)',
    detail: 'Atmospheric Burning Puzzles',
    image: bonfire,
    dev: 'Draknek',
    link: 'https://store.steampowered.com/app/1147890/Bonfire_Peaks/',
  },
  {
    name: 'Kaiju Wars (2022)',
    detail: 'Monster Mashing Tactics',
    image: kaiju,
    dev: 'Michael Long, Foolish Mortals Games',
    link: 'https://store.steampowered.com/app/1508400/Kaiju_Wars/?curator_clanid=33121977',
  },
  {
    name: 'Kitaria Fables (2021)',
    detail: 'ARPG with Farming',
    image: kitaria,
    dev: 'PQube',
    link: 'https://store.steampowered.com/app/1356280/Kitaria_Fables/',
  },
  {
    name: 'Tenderfoot Tactics (2020)',
    detail: 'Lovely Lowpoly Tactics',
    image: tenderfoot,
    dev: 'Ice Water Games',
    link: 'https://store.steampowered.com/app/1061610/Tenderfoot_Tactics/',
  },
  {
    name: 'Warhammer 40,000: Gladius - Relics of War (2018)',
    detail: 'Grand Strategy Warhammer',
    image: warhammer,
    dev: 'Slitherine Ltd.',
    link: 'https://store.steampowered.com/app/489630/Warhammer_40000_Gladius__Relics_of_War/',
  },
  {
    name: 'Absolute Drift (2015)',
    detail: 'Chill Drifting',
    image: drift,
    dev: 'Funselektor Labs Inc.',
    link: 'https://store.steampowered.com/app/320140/Absolute_Drift/',
  },
  {
    name: 'Aeronautica Imperialis: Flight Command (2020)',
    detail: 'Turn-based Top Gun',
    image: aeronautica,
    dev: 'Green Man Gaming Publishing',
    link: 'https://store.steampowered.com/app/610160/Aeronautica_Imperialis_Flight_Command/?curator_clanid=33034161',
  },

  {
    name: 'Ancient Enemy (2020) ',
    detail: 'Modern Fantasy Solitaire',
    image: ancient,
    dev: 'Grey Alien Games',
    link: 'https://store.steampowered.com/app/993790/Ancient_Enemy/?curator_clanid=33035039',
  },
  {
    name: 'Aporia: Beyond The Valley (2017)',
    detail: 'Stunning Story Puzzler',
    image: aporia,
    dev: 'Invisible Walls',
    link: 'https://store.steampowered.com/app/573130/Aporia_Beyond_The_Valley/',
  },
  {
    name: 'Ato (2020)',
    detail: 'Cat Samurai Adventure',
    image: ato,
    dev: 'Tiny Warrior Games',
    link: 'https://store.steampowered.com/app/1096180/Ato/?curator_clanid=35058019',
  },
  {
    name: 'Big Crown Showdown (2018)',
    detail: 'Frantic Fall-Knights',
    image: showdown,
    dev: 'Hyper Luminal Games Ltd',
    link: 'https://store.steampowered.com/app/793360/Big_Crown_Showdown/',
  },

  {
    name: 'Chaos Reborn (2015)',
    detail: 'Tactical Wizard Wars',
    image: chaos,
    dev: 'Snapshot games',
    link: 'https://store.steampowered.com/app/319050/Chaos_Reborn/',
  },
  {
    name: 'Chatventures (2020)',
    detail: 'Popping Micro-games',
    image: 'https://cdn.cloudflare.steamstatic.com/steam/apps/1265850/header.jpg?t=1639496738',
    dev: 'Sokpop Collective',
    link: 'https://store.steampowered.com/app/1265850/Chatventures/',
  },
  {
    name: 'Chroma Squad (2015)',
    detail: 'Power Ranger Manager',
    image: chroma,
    dev: 'Behold Studios',
    link: 'https://store.steampowered.com/app/251130/Chroma_Squad/',
  },
  {
    name: 'Chronicon (2020)',
    detail: 'Live Loot Level-Up',
    image: chronicon,
    dev: 'Subworld',
    link: 'https://store.steampowered.com/app/375480/Chronicon/',
  },
  {
    name: 'CHUCHEL (2018)',
    detail: 'Comedy Mushroom Adventure',
    image: chuchel,
    dev: 'Amanita Design',
    link: 'https://store.steampowered.com/app/711660/CHUCHEL/?curator_clanid=6859823',
  },
  {
    name: 'City Climber (2017)',
    detail: 'Ragdoll Climbing Fun',
    image: climber,
    dev: 'Ondrej Angelovic',
    link: 'https://store.steampowered.com/app/538840/City_Climber/',
  },
  {
    name: 'Concrete Jungle (2015)',
    detail: 'Classic City Builder',
    image: concrete,
    dev: 'Colepowered Games',
    link: 'https://store.steampowered.com/app/400160/Concrete_Jungle/',
  },

  {
    name: 'Crazy Machines 3 (2016)',
    detail: 'Wacky Physics Sandbox',
    image: crazy,
    dev: 'Fakt Software',
    link: 'https://store.steampowered.com/app/351920/Crazy_Machines_3/',
  },
  {
    name: 'CryoFall (2021)',
    detail: 'Sci-fi Multiplayer Survival',
    image: cyrofall,
    dev: 'AtomicTorch Studio',
    link: 'https://store.steampowered.com/app/829590/CryoFall/',
  },
  {
    name: 'Danger Scavengers (2021)',
    detail: 'Cyberpunk Rooftop Romp',
    image: danger,
    dev: 'Star Drifters',
    link: 'https://store.steampowered.com/app/1169740/Danger_Scavenger/?curator_clanid=37957996',
  },
  {
    name: 'Dark Nights with Poe and Munro (2020)',
    detail: 'Supernatural FMV Strangeness',
    image: dark,
    dev: "D'Avekki Studios Ltd",
    link: 'https://store.steampowered.com/app/1098170/Dark_Nights_with_Poe_and_Munro/',
  },
  {
    name: 'Demolish & Build 2018 (2018)',
    detail: 'Knock Stuff Over',
    image: demolish,
    dev: 'PlayWay',
    link: 'https://store.steampowered.com/app/577670/Demolish__Build_2018/',
  },
  {
    name: 'Deponia (2012)',
    detail: 'Iconic Point-and-Click',
    image: 'https://cdn.cloudflare.steamstatic.com/steam/apps/214340/header.jpg?t=1646937169',
    dev: 'Daedalic Entertainment',
    link: 'https://store.steampowered.com/app/214340/Deponia/',
  },
  {
    name: 'DESOLATE (2019)',
    detail: 'Coop Zombie Survival',
    image: desolate,
    dev: 'HYPETRAIN DIGITAL',
    link: 'https://store.steampowered.com/app/671510/DESOLATE/',
  },
  {
    name: 'Discolored (2019)',
    detail: 'Perform Pigment Puzzles',
    image: discolored,
    dev: 'Godbey Games',
    link: 'https://store.steampowered.com/app/933860/Discolored/?curator_clanid=33594103',
  },
  {
    name: 'Driftland: The Magic Revival (2019)',
    detail: 'Floating Wizards 4X',
    image: driftland,
    dev: '',
    link: 'https://store.steampowered.com/app/718650/Driftland_The_Magic_Revival/',
  },
  {
    name: 'Dude, Stop (2018)',
    detail: 'Be Annoying',
    image: dude,
    dev: 'Team HalfBeard',
    link: 'https://store.steampowered.com/app/574560/Dude_Stop/',
  },
  {
    name: 'Epic Battle Fantasy 5 (2018)',
    detail: 'Tongue-in-cheek JRPG',
    image: 'https://cdn.cloudflare.steamstatic.com/steam/apps/432350/header.jpg?t=1604853612',
    dev: 'Matt Roszak',
    link: 'https://store.steampowered.com/app/432350/Epic_Battle_Fantasy_5/?curator_clanid=34315420',
  },
  {
    name: 'Eternal Hope (2020)',
    detail: 'Cinematic Puzzle Platformer',
    image: eternal,
    dev: 'Kwalee Ltd',
    link: 'https://store.steampowered.com/app/1162280/Eternal_Hope/?curator_clanid=39269540',
  },

  {
    name: 'Fit For a King (2019)',
    detail: 'Marry Divorce Execute',
    image: fit,
    dev: 'Kitfox Games',
    link: 'https://store.steampowered.com/app/1110380/Fit_For_a_King/',
  },
  {
    name: 'Flipper Volcano (2020)',
    detail: 'Popping Micro-games',
    image: 'https://cdn.cloudflare.steamstatic.com/steam/apps/1413350/header.jpg?t=1639497557',
    dev: 'Sokpop Collective',
    link: 'https://store.steampowered.com/app/1413350/Flipper_Volcano/',
  },
  {
    name: 'Fury Unleashed (2020)',
    detail: 'Frantic Roguelike Shooter',
    image: fury,
    dev: 'Awesome Games Studio',
    link: 'https://store.steampowered.com/app/465200/Fury_Unleashed/',
  },
  {
    name: 'Geneshift EA (2017)',
    detail: 'Cars Guns Action',
    image: geneshift,
    dev: 'Nik Nak Studios',
    link: 'https://store.steampowered.com/app/308600/Geneshift/',
  },
  {
    name: 'Hellblusser (2021)',
    detail: 'Popping Micro-games',
    image: 'https://cdn.cloudflare.steamstatic.com/steam/apps/1695480/header.jpg?t=1635855776',
    dev: 'Sokpop Collective',
    link: 'https://store.steampowered.com/app/1695480/Hellblusser/',
  },

  {
    name: 'House (2020)',
    detail: 'Spooky Pixel House',
    image: house,
    dev: 'Bark Bark Games',
    link: 'https://store.steampowered.com/app/1444350/House/',
  },
  {
    name: 'Idle Champions - Polymorphed Shandie Skin & Feat Pack (2022)',
    detail: 'Buff Your Champion',
    image: idleone,
    dev: 'Codename Entertainment',
    link: 'https://store.steampowered.com/app/2071680/Idle_Champions__Polymorphed_Shandie_Skin__Feat_Pack/',
  },
  {
    name: 'Idle Champions - Prismeer Sentry Skin & Feat Pack (2022)',
    detail: 'Buff Your Champion',
    image: idletwo,
    dev: 'Codename Entertainment',
    link: 'https://store.steampowered.com/app/1845102/Idle_Champions__Prismeer_Sentry_Skin__Feat_Pack/',
  },

  {
    name: 'JARS (2021)',
    detail: 'Creepy Puzzles',
    image: jars,
    dev: 'Mousetrap Games',
    link: 'https://store.steampowered.com/app/1590750/JARS/',
  },

  {
    name: 'KILLRUN (2022)',
    detail: 'Run Gun Parkour!',
    image: killrun,
    dev: 'Bulkhead',
    link: 'https://store.steampowered.com/app/1442170/KILLRUN/',
  },
  {
    name: 'King Pins (2020)',
    detail: 'Popping Micro-games',
    image: 'https://cdn.cloudflare.steamstatic.com/steam/apps/1459870/header.jpg?t=1639497860',
    dev: 'Sokpop Collective',
    link: 'https://store.steampowered.com/app/1459870/King_Pins/',
  },

  {
    name: 'Little Inferno (2012)',
    detail: 'Burn Your Toys',
    image: inferno,
    dev: 'Tomorrow Corporation',
    link: 'https://store.steampowered.com/app/221260/Little_Inferno/',
  },

  {
    name: 'Lucifer Within Us (2020)',
    detail: 'Intricate Demonic Detective',
    image: lucifer,
    dev: 'Kitfox Games',
    link: 'https://store.steampowered.com/app/717560/Lucifer_Within_Us/',
  },
  {
    name: 'Mad Experiments: Escape Room (2020)',
    detail: 'Mind-bending Escape Room',
    image: mad,
    dev: 'PlayTogether Studio',
    link: 'https://store.steampowered.com/app/1201550/Mad_Experiments_Escape_Room/?curator_clanid=41399979',
  },
  {
    name: 'Maiden and Spell (2020)',
    detail: 'Flying Magic Bullet-hell',
    image: maiden,
    dev: 'mino_dev LLC',
    link: 'https://store.steampowered.com/app/1004770/Maiden_and_Spell/',
  },
  {
    name: 'Mech Mechanic Sim (2021)',
    detail: 'Build-a-mech workshop',
    image: mech,
    dev: 'Art Games Studio SA / Polyslash / HeartBeat Games',
    link: 'https://store.steampowered.com/app/1044980/Mech_Mechanic_Simulator/',
  },
  {
    name: 'Men of War: Assault Squad 2 (2014)',
    detail: 'Tanks Troops Tactics',
    image: men,
    dev: 'Fulqrum Games',
    link: 'https://store.steampowered.com/app/244450/Men_of_War_Assault_Squad_2/',
  },
  {
    name: 'Moon Hunters (2016)',
    detail: 'Tiny DnD Adventures',
    image: moon,
    dev: 'Kitfox Games',
    link: 'https://store.steampowered.com/app/320040/Moon_Hunters/',
  },
  {
    name: 'Orbi Universo (2020)',
    detail: 'Abstract Civ Strategy',
    image: orbi,
    dev: 'Orbi Universo Team',
    link: 'https://store.steampowered.com/app/1090670/Orbi_Universo/',
  },
  {
    name: 'Paperball (2020)',
    detail: 'Stunt Ball Racing',
    image: paper,
    dev: 'Cliax Games',
    link: 'https://store.steampowered.com/app/1198510/Paperball/',
  },
  {
    name: 'Paradise Lost (2021)',
    detail: 'Postapocalyptic Adventure',
    image: paradise,
    dev: 'All in! Games',
    link: 'https://store.steampowered.com/app/982720/Paradise_Lost/',
  },
  {
    name: 'Pendragon (2020)',
    detail: 'Mythic Tactical Narrative',
    image: pendragon,
    dev: 'inkle',
    link: 'https://store.steampowered.com/app/1240050/Pendragon/',
  },
  {
    name: 'Plague Inc: Evolved (2016)',
    detail: 'End The World',
    image: plague,
    dev: 'Ndemic Creations',
    link: 'https://store.steampowered.com/app/246620/Plague_Inc_Evolved/',
  },

  {
    name: 'Pocket Watch (2020)',
    detail: 'Popping Micro-games',
    image: 'https://cdn.cloudflare.steamstatic.com/steam/apps/1510620/header.jpg?t=1639498803',
    dev: 'Sokpop Collective',
    link: 'https://store.steampowered.com/app/1510620/Pocket_Watch/',
  },
  {
    name: "Popo's Tower (2020)",
    detail: 'Popping Micro-games',
    image: 'https://cdn.cloudflare.steamstatic.com/steam/apps/1338130/header.jpg?t=1639491498',
    dev: 'Sokpop Collective',
    link: 'https://store.steampowered.com/app/1338130/Popos_Tower/',
  },
  {
    name: 'Primal Light (2020)',
    detail: '16bit Boss Battler',
    image: primal,
    dev: 'Fat Gem',
    link: 'https://store.steampowered.com/app/771420/Primal_Light/',
  },
  {
    name: 'Pyramida (2020)',
    detail: 'Popping Micro-games',
    image: 'https://cdn.cloudflare.steamstatic.com/steam/apps/1390010/header.jpg?t=1639497917',
    dev: 'Sokpop Collective',
    link: 'https://store.steampowered.com/app/1390010/pyramida/',
  },
  {
    name: 'Seals of the Bygone EA (2020)',
    detail: 'Roguelike Dungeon Delver',
    image: seals,
    dev: 'rologfos',
    link: 'https://store.steampowered.com/app/1093790/Seals_of_the_Bygone/',
  },
  {
    name: 'Sok-worlds (2020)',
    detail: 'Popping Micro-games',
    image: 'https://cdn.cloudflare.steamstatic.com/steam/apps/1263820/header.jpg?t=1639497082',
    dev: 'Sokpop Collective',
    link: 'https://store.steampowered.com/app/1263820/sokworlds/',
  },
  {
    name: 'Space Crew (2020)',
    detail: 'Space Management Adventure',
    image: space,
    dev: 'Curve Digital',
    link: 'https://store.steampowered.com/app/1176710/Space_Crew_Legendary_Edition/',
  },
  {
    name: 'Sunlight (2021)',
    detail: 'Chilled, wholesome trees',
    image: sunlight,
    dev: 'Krillbite Studio',
    link: 'https://store.steampowered.com/app/1451120/Sunlight/',
  },
  {
    name: "Swords 'n Magic and Stuff EA (2020)",
    detail: 'Cute Multiplayer RPG',
    image: swords,
    dev: 'Kindred Games',
    link: 'https://store.steampowered.com/app/810040/Swords_n_Magic_and_Stuff/',
  },
  {
    name: 'Tanuki Sunset (2020)',
    detail: 'Skateboarding Racoons',
    image: tanuki,
    dev: 'Rewind Games',
    link: 'https://store.steampowered.com/app/1251460/Tanuki_Sunset/',
  },

  {
    name: 'The Dungeon Beneath (2020)',
    detail: 'Roguelike Dungeon Battler',
    image: dungeon,
    dev: 'Puzzle Box Games',
    link: 'https://store.steampowered.com/app/1359120/The_Dungeon_Beneath/',
  },
  {
    name: 'The Galactic Junkers (2022)',
    detail: 'Comedic space adventures',
    image: galactic,
    dev: 'Green Man Gaming Publishing',
    link: 'https://store.steampowered.com/app/1243160/The_Galactic_Junkers/?curator_clanid=33034161',
  },
  {
    name: 'The Hex (2018)',
    detail: 'Creepy Pixel Murder',
    image: hex,
    dev: 'Daniel Mullins Games',
    link: 'https://store.steampowered.com/app/510420/The_Hex/?curator_clanid=33030951',
  },
  {
    name: 'The Turing Test (2016)',
    detail: 'Sci-Fi Puzzle Mystery',
    image: turing,
    dev: 'Bulkhead',
    link: 'https://store.steampowered.com/app/499520/The_Turing_Test/?curator_clanid=42656369',
  },
  {
    name: 'Turnip Boy Commits Tax Evasion (2021)',
    detail: 'Vegetable Crime Sim',
    image: turnip,
    dev: 'Graffiti Games',
    link: 'https://store.steampowered.com/app/1205450/Turnip_Boy_Commits_Tax_Evasion/',
  },
  {
    name: "Uligo: A Slime's Hike (2022)",
    detail: 'Precision platforming, precisely',
    image: uligo,
    dev: 'Nôrdika Studio',
    link: 'https://store.steampowered.com/app/1971790/Uligo_A_Slimes_Hike/',
  },
  {
    name: 'Vibrant Venture (2020)',
    detail: 'Cute Platforming Action',
    image: vibrant,
    dev: 'Semag Games',
    link: 'https://store.steampowered.com/app/1264520/Vibrant_Venture/',
  },
  {
    name: 'Viscera Cleanup Detail (2015)',
    detail: 'Horror Aftermath Cleaning ',
    image: viscera,
    dev: 'RuneStorm Games',
    link: 'https://store.steampowered.com/app/246900/Viscera_Cleanup_Detail/?curator_clanid=32963207',
  },

  {
    name: 'WARSAW (2019)',
    detail: 'Stylish WW2 Tactics',
    image: warsaw,
    dev: 'Retrovibe',
    link: 'https://store.steampowered.com/app/1026420/WARSAW/',
  },
  {
    name: 'Wunderling DX (2020)',
    detail: 'Retro Puzzle Platforming',
    image: wunderling,
    dev: 'Bitwave Games',
    link: 'https://store.steampowered.com/app/732930/Wunderling_DX/',
  },

  {
    name: 'Zombie Rollerz: Pinball Heroes (2022)',
    detail: 'Pinball Zombie Madness',
    image: zombie,
    dev: 'Zing Games Inc.',
    link: 'https://store.steampowered.com/app/915230/Zombie_Rollerz_Pinball_Heroes/',
  },
  {
    name: 'ΔV (DELTA): Rings of Saturn (2019)',
    detail: 'Realistic Space Mining',
    image: rings,
    dev: 'Kodera Software',
    link: 'https://store.steampowered.com/app/846030/V_Rings_of_Saturn/?curator_clanid=35530213',
  },
  {
    name: 'yogs store 25%  discount',
    detail: '25% off the whole store',
    image: yogs,
    dev: '',
    link: 'https://store.yogscast.com/en-us',
  },
  {
    name: 'fresh store 25%  discount',
    detail: '25% off these collections; RTGame, High Rollers, Hat Films, Spiffing Brit & ISP',
    image: fresh,
    dev: '',
    link: 'https://freshstore.co/',
  },
  {
    name: 'Fanatical Wheel spin codes',
    detail: 'redeem your code here: https://www.fanatical.com/en/redeem-code',
    image: fanatical,
    dev: '',
    link: 'https://www.fanatical.com/en/redeem-code',
  },
  {
    name: 'Displate 40% off discount',
    detail: '40% off at displate (redeemable on the displate website)',
    image: displate,
    dev: '',
    link: 'https://displate.com/',
  },
]
